export const isMobile = window.innerWidth <= 500;
export const isTall = window.innerHeight > 650;
export const herokuURL = 'https://tunewise.herokuapp.com';
